import { render } from "./index.vue?vue&type=template&id=a03751f8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=a03751f8&lang=less&scoped=true"

import exportComponent from "/Users/ym/Desktop/tianmuli/tml-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a03751f8"]])

export default __exports__